import React from 'react'
import { uniqueKey } from '../../../common/keys'
import { Icon } from 'semantic-ui-react'

const _icons = {
  all: 'users',
  direct: 'user circle'
}

const LinkIcon = ({ hasDirectLink, showAllLinks, _keyy }) => {

  if (hasDirectLink) {
    return <div className={'icon-ind'} key={uniqueKey('cs', 'dl', _keyy)}>
      <Icon corner name={_icons.direct} color={'blue'} />
    </div>
  } else {
    if (showAllLinks) {
      return <div className={'icon-ind'} key={uniqueKey('cs', 'dl', _keyy)}>
        <Icon name={_icons.all} color={'grey'} />
      </div>
    }
  }
}

export default LinkIcon
